// extracted by mini-css-extract-plugin
export default {"dropdown":"DropDownMenu_dropdown__HKrVS","dropdown-item":"DropDownMenu_dropdown-item__B0v8c"};